import { Pipe, PipeTransform } from '@angular/core'
import { isArray } from 'lodash-es'

@Pipe({
    name: 'joinNames',
    standalone: false
})
export class JoinNamesPipe implements PipeTransform {
  public transform(values: any): string {
    if (!isArray(values) || !values?.length) {
      return ''
    }

    return values.map((item) => item.name).join(', ')
  }
}
